class CreateMultiPackageReq {
  constructor() {
    this.packageSessions = [];
    this.patientId = undefined;
    this.packageName = undefined;
  }
}
export default CreateMultiPackageReq;
